import { create } from 'zustand';
import { dropsApi } from '@/lib/api';
import { useInventoryStore } from './inventoryStore';

interface DropState {
  // drops: GallerySingleDrop[]
  claimDrop: (dropSlug: string) => Promise<any>;
}

export const useDropStore = create<DropState>()(() => ({
  claimDrop: async (dropSlug: string) => {
    const resp = await dropsApi.postClaimDrop(dropSlug);
    // Update inventory
    useInventoryStore.getState().fetchInventorySingleDrops();
    return resp;
  },
}));
